"use client";

import { useHeaderContext } from "./header-context";

export const HeaderOverlay = () => {
  const { openId } = useHeaderContext();
  const isOpen = Boolean(openId);
  return (
    <div
      aria-hidden="true"
      className="
        pointer-events-none fixed inset-x-0 top-14 bottom-0 z-10 hidden bg-black
        opacity-0 transition-opacity duration-300

        data-[open='true']:opacity-40

        md:block
      "
      data-open={isOpen}
    />
  );
};
